import api from '../config/axios-conf';

// ===== Gói dịch vụ (Service Packages) =====
// Đồng bộ với app: screens/admin/ServiceAdmin.js, PackageEditor.js, CustomerPackage*.

export const getPackages = () =>
    api.get('/service-packages');

export const getPackageById = (id) =>
    api.get(`/service-packages/${id}`);

// nonEmpty=true: chỉ trả danh mục đã có ít nhất 1 gói (giống app)
export const getPackageCategories = (nonEmpty = true) =>
    api.get('/service-packages/categories', { params: nonEmpty ? { nonEmpty: true } : {} });

export const createPackage = (data) =>
    api.post('/service-packages', data);

export const updatePackage = (id, data) =>
    api.put(`/service-packages/${id}`, data);

export const deletePackage = (id) =>
    api.delete(`/service-packages/${id}`);

// ===== Thẻ gói của khách (Customer Packages) =====

export const getCustomerPackages = (customerId) =>
    api.get('/customer-packages', { params: { customerId } });

export const getCustomerPackageById = (id) =>
    api.get(`/customer-packages/${id}`);

// ===== Hoa hồng dùng cho cấu hình gói (filter type=percent ở phía gọi) =====

export const getCommissionAll = () =>
    api.get('/services/commissionAll');
